import React, { useRef } from "react";
import "./style.css";

interface Props {
  label?: string;
  type?: string;
  error?: string | boolean;
  hint?: string;
  name: string;
  className?: string;
  readonly?: boolean;
  placeHolder: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  horizontal?: boolean;
  icon?: string;
  iconColor?: string;
  handleIconClick?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
}

const TextInput: React.FunctionComponent<Props> = (props: Props) => {
  const refInput = useRef<HTMLInputElement>(null);

  const {
    type,
    className,
    placeHolder,
    value,
    onChange,
    name,
    label,
    horizontal,
    error,
    readonly,
    icon,
    iconColor,
    handleIconClick,
  } = props;

  const handleFocus = (): void => {
    if (refInput && refInput.current) refInput.current.focus();
  };

  const handleIconBtnClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ): void => {
    handleFocus();
    if (handleIconClick) handleIconClick(e);
  };

  return (
    <>
      <input type="text" className="w-full" />
      {!!label && (
        <div className={`${horizontal ? "md:w-1/3" : ""}`}>
          <label
            className={`block caption-12 text-gray-700 mb-2 ${
              horizontal ? "md:text-right mb-1 md:mb-0 pr-4" : "text-xs"
            }`}
            htmlFor={name}
          >
            {label}
          </label>
        </div>
      )}
      <div className={`relative ${horizontal ? "md:w-2/3" : ""}`}>
        <input
          type={type}
          name={name}
          className={`${className} ${
            error
              ? "focus:bg-red-light-tint-2 focus:border-red-primary"
              : "focus:bg-celtic-blue-light-tint-2 focus:border-celtic-blue-primary"
          } bg-background-dirt-snow px-2 pt-2 input text-neutral-charcoal appearance-none bg-vanilla  border-b divide-background-rain-cloud focus:outline-none`}
          data-testid={name}
          value={value}
          onChange={onChange}
          readOnly={readonly}
        />
        <span
          className={`${
            error ? "text-red" : "text-blue"
          } absolute input-placeholder text-neutral-black-coral caption-12 transition-all duration-300 ease-in-out`}
        >
          {placeHolder}
        </span>
        {icon && (
          <button
            onClick={handleIconBtnClick}
            type="button"
            className="absolute icon-eye text-neutral-charcoal focus:outline-none outline-none text-input-button"
          >
            <i className={`far ${icon} ${iconColor}`} />
          </button>
        )}
      </div>
      {!!error && (
        <div className="flex justify-between ">
          <div>
            <p
              className="text-red-shade caption-12 pt-1 leading-4 pl-1"
              data-testid={`error-${name}`}
            >
              {error}
            </p>
          </div>
          <div>
            <i className="fas fa-exclamation-triangle text-red-primary mt-1 mr-2 fa-sm" />
          </div>
        </div>
      )}
    </>
  );
};

TextInput.defaultProps = {
  type: "text",
  label: "",
  error: "",
  hint: "",
  readonly: false,
  horizontal: false,
  className: "",
  icon: "",
  iconColor: "",
  handleIconClick: (): void => {
    //
  },
  onChange: (): void => {
    //
  },
};

export default TextInput;
